import { floor } from 'lodash'
import Numeral from 'numeral'

Numeral.defaultFormat('0,0.00')
Numeral.zeroFormat('0.00')
Numeral.nullFormat('0.00')

export const formatNumber = (number) => {
  return Numeral(number).format()
}

export const toNumber = (number = 0) => {
  return Numeral(number).value()
}

export const isNumberEqual = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()
  return numValue1 === numValue2
}

export const isNumber = (value) => {
  const numValue = Numeral(value).value()
  return {
    equal: (comparator) => {
      const numComparator = Numeral(comparator).value()
      return numValue === numComparator
    },
    greaterThan: (comparator) => {
      const numComparator = Numeral(comparator).value()
      return numValue > numComparator
    },
  }
}

export const add = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()
  const add = Numeral(numValue1).add(numValue2).value()
  return Numeral(add).format()
}

export const subtract = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()
  const subtract = Numeral(numValue1).subtract(numValue2).value()
  return Numeral(subtract).format()
}

export const multiply = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()
  const multiply = Numeral(numValue1).multiply(numValue2).value()
  return Numeral(multiply).format()
}

export const divide = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()

  // fall back to 0
  if (numValue2 === 0) return Numeral(0).format()
  const divide = Numeral(numValue1).divide(numValue2).value()
  return Numeral(divide).format()
}

export const divideValue = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()

  // fall back to 0
  if (numValue2 === 0) return 0
  const divide = Numeral(numValue1).divide(numValue2).value()
  return divide
}

export const divideFlooring = (value1, value2) => {
  const numValue1 = Numeral(value1).value()
  const numValue2 = Numeral(value2).value()

  // fall back to 0
  if (numValue2 === 0) return Numeral(0).format()
  const divide = Numeral(numValue1).divide(numValue2).value()
  const divideFloor = floor(divide, 2)
  return Numeral(divideFloor).format()
}

export const percentage = (value, percent) => {
  const numValue = Numeral(value).value()
  const ratio = Numeral(percent).divide(100).value()
  const percentage = Numeral(numValue).multiply(ratio).value()
  return Numeral(percentage).format()
}

export const period = (value, divider) => {
  const numValue = Numeral(value).value()
  const numDivider = Numeral(divider).value()

  // fall back to 0
  if (numDivider === 0) return Numeral(0).format()
  const period = Numeral(numValue).divide(numDivider).multiply(100).value()
  return Numeral(period).format()
}

export const findPercentage = (value, total) => {
  const numValue = Numeral(value).value()
  const numTotal = Numeral(total).value()

  // fall back to 0
  if (numTotal === 0) return Numeral(0).format()
  const percentage = Numeral(numValue).divide(numTotal).multiply(100).value()
  return Numeral(percentage).format()
}

export const sumBy = (arrayObject, identity, format = '0.00') => {

  // format is optional
  const sumByKey = arrayObject.reduce((sum, i) => {
    let target = 0
    if (typeof identity === 'string') {
      target = Numeral(i[identity]).value() || 0
    } else if (typeof identity === 'function') {
      target = Numeral(identity(i)).value()
    }
    return Numeral(sum).add(target).format(format)
  }, 0)
  return Numeral(sumByKey).format()
}

export const sumByIf = (arrayObject, key, callback) => {
  // format is optional
  const sumByKey = arrayObject.reduce((sum, i) => {
    const target = Numeral(i[key]).value() || 0
    return callback(i) ? Numeral(sum).add(target) : sum
  }, 0)
  return Numeral(sumByKey).format()
}

export const getDifferenceValueFormat = (valueA, valueB) => {
  return Numeral(valueA).subtract(Numeral(valueB).value()).format()
}

export const getDifferencePercentageFormat = (valueA, valueB) => {
  return Numeral(valueA).subtract(Numeral(valueB).value()).multiply(100).divide(Numeral(valueB).value()).format()
}




// WEBPACK FOOTER //
// ./src/function/math.js